// extracted by mini-css-extract-plugin
export default {"switch":"style_switch__dQ78U","slider":"style_slider__CIw2q","round":"style_round__zIEhO"};